var React = require('react');

function DigitalGiftCardInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","strokeLinejoin":"round","strokeWidth":"2","stroke":"currentColor"},[React.createElement("path",{"d":"M18 7h5M5 11h30m1 42v4.26c0 2 0 2.74-2 2.74H7c-1.333-.371-2-1.038-2-2V6c0-1.443.643-2 2-2h27c1.357 0 2 .557 2 2v14","strokeLinecap":"square","key":0}),React.createElement("g",{"transform":"translate(14 20)","key":1},[React.createElement("rect",{"strokeLinecap":"square","width":"45","height":"33","rx":"4","key":0}),React.createElement("path",{"d":"M13 21l5.21-5M23 21l-5-5M18 9.787L9 7v10.5l9-2.5zm0 0L27 7v10.421L18 15z","strokeLinecap":"square","key":1}),React.createElement("path",{"d":"M1.086 12H8.9M18 .868V33m9.79-21h16.5","strokeLinecap":"round","key":2})])]));
}

DigitalGiftCardInline.defaultProps = {"viewBox":"0 0 64 64"};

module.exports = DigitalGiftCardInline;

DigitalGiftCardInline.default = DigitalGiftCardInline;
